export const capitalizeFirstLetter = (value: string | null | undefined): string => {
    if (!value) {
        return "";
    }
    return value.charAt(0).toUpperCase() + value.slice(1);
};

export const toNullableStringValue = (value: unknown): string | null => {
    if (value === null || value === undefined) {
        return null;
    }

    return toStringValue(value);
};

export const toStringValue = (value: unknown): string => typeof value === "string" ? value : "";

export const toDisplayStringValue = (value: unknown, fallback = "N/A"): string => {
    if (typeof value !== "string") {
        return fallback;
    }

    return value.trim() ? value : fallback;
};

export const toDisplayNumberValue = (value: unknown, fallback = "N/A"): string => {
    if (typeof value !== "number" || Number.isNaN(value)) {
        return fallback;
    }

    return value ? value.toString() : fallback;
};

export const truncateString = (value: string | null | undefined, maxLength: number = 20): string | null | undefined => {
    if (!value || value.length <= maxLength) {
        return value;
    }

    return `${value.substring(0, Math.max(0, maxLength - 3))}...`;
};
